import {
  VIEWTRANSACTIONDETAILS_SUCCESS,
  VIEWTRANSACTIONDETAILS_FAILED,
  RESET_VIEWTRANSACTIONDETAILS,
  LOADING_VIEWTRANSACTIONDETAILS,
  NETWORK_ERROR_VIEWTRANSACTIONDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VIEWTRANSACTIONDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case VIEWTRANSACTIONDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case VIEWTRANSACTIONDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_VIEWTRANSACTIONDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_VIEWTRANSACTIONDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
